const headerData = [{
		types: "selection",
		columnwidth: 50,
	},
	{
		prop: "BCMID",
		label: "编号",
		columnwidth: 120,
	},
	{
		prop: "BOSSCode",
		label: "关系标识",
		columnwidth: 120,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 120,
	},
	{
		prop: "BOSSName",
		label: "公司负责人",
		columnwidth: 120,
	},
	{
		prop: "CusName",
		label: "经销商",
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 120,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 125,
	}
];
export default headerData;